import React from "react";
import QRCode from "react-qr-code";

import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LanguageIcon from '@mui/icons-material/Language';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import BusinessIcon from '@mui/icons-material/Business';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import TagIcon from '@mui/icons-material/Tag';

export const GLOBAL_ICON_CONFIG = {
    headerIconSize: 18,
    footerIconSize: 14,
    spacingRight: "6px",
    opacity: 0.85,
    color: "inherit",
};

const getIcon = (key, customSize = null) => {
    if (!key) return null;
    const lowerKey = key.toLowerCase();
    const size = customSize || GLOBAL_ICON_CONFIG.headerIconSize;

    const iconStyle = {
        fontSize: `${size}px`,
        opacity: GLOBAL_ICON_CONFIG.opacity,
        color: GLOBAL_ICON_CONFIG.color,
        display: "block" // Strictly block to remove phantom line-heights
    };

    let IconComp = null;
    if (lowerKey.includes('email')) IconComp = EmailIcon;
    else if (lowerKey.includes('phone') || lowerKey.includes('mobile')) IconComp = PhoneIcon;
    else if (lowerKey.includes('address') || lowerKey.includes('location')) IconComp = LocationOnIcon;
    else if (lowerKey.includes('website') || lowerKey.includes('web')) IconComp = LanguageIcon;
    else if (lowerKey.includes('linkedin')) IconComp = LinkedInIcon;
    else if (lowerKey.includes('branch') || lowerKey.includes('office')) IconComp = BusinessIcon;
    else if (lowerKey.includes('cin')) IconComp = CorporateFareIcon;
    else if (lowerKey.includes('gst')) IconComp = TagIcon;

    if (!IconComp) return null;

    return <IconComp style={iconStyle} />;
};

export const HEADER_MIN_HEIGHT = "120px";
export const FOOTER_MIN_HEIGHT = "100px";

export const TemplateHeader = ({
    isPdfMode,
    headerBg,
    showHeaderBg,
    textColorClass,
    subTextColorClass,
    isStacked,
    isLogoLeft,
    logoWrapperClasses,
    textClasses,
    textAlign,
    logoSrc,
    logoSize,
    showCompanyInfo,
    headerFields,
    companyName, companyEmail, companyPhone, companyAddress, visibleFields, customFields
}) => {

    const containerClasses = isPdfMode
        ? "w-full py-6 px-20 z-10 flex shrink-0"
        : "flex px-8 py-6 transition-all duration-300";

    const layoutClasses = isStacked ? 'flex-col justify-center gap-4'
        : isLogoLeft ? 'flex-row items-center gap-8'
            : 'flex-row-reverse items-center gap-8';

    let fieldsToRender = [];
    if (headerFields && headerFields.length > 0) {
        fieldsToRender = headerFields;
    } else {
        fieldsToRender = [
            { key: 'name', value: companyName, isVisible: visibleFields?.name !== false },
            { key: 'address', value: companyAddress, isVisible: visibleFields?.address !== false },
            { key: 'email', value: companyEmail, isVisible: visibleFields?.email !== false },
            { key: 'phone', value: companyPhone, isVisible: visibleFields?.phone !== false },
            ...(customFields || [])
        ];
    }

    return (
        <div
            className={`${containerClasses} ${layoutClasses} ${!isPdfMode ? textColorClass : ''}`}
            style={{
                backgroundColor: showHeaderBg ? headerBg : 'transparent',
                minHeight: HEADER_MIN_HEIGHT
            }}
        >
            {/* {logoSrc && (
                <div className={`flex ${isStacked ? `w-full ${logoWrapperClasses}` : "shrink-0"}`}>
                    <img
                        src={logoSrc}
                        alt="Logo"
                        className={`${logoSizeClass} w-auto object-contain ${!isPdfMode ? 'transition-all duration-300' : ''}`}
                    />
                </div>
            )} */}

            {logoSrc && (
                <div className={`flex ${isStacked ? `w-full ${logoWrapperClasses}` : "shrink-0"}`}>
                    <img
                        src={logoSrc}
                        alt="Logo"
                        style={{
                            height: logoSize,
                            width: 'auto',
                            objectFit: 'contain'
                        }}
                        className={`${!isPdfMode ? 'transition-all duration-300' : ''}`}
                    />
                </div>
            )}

            {showCompanyInfo && (
                <div className={`flex flex-col justify-center ${isStacked ? 'w-full' : 'flex-1'} ${textClasses} ${!isPdfMode ? 'gap-1 transition-all duration-300' : ''}`}>

                    {fieldsToRender.map((f, i) => {
                        if (!f.isVisible || !f.value) return null;

                        if (f.key === 'name') {
                            return (
                                <h1 key={`header-f-${i}`} className={`font-bold uppercase mb-2 leading-none ${textColorClass} ${isPdfMode ? 'text-2xl' : 'text-xl tracking-wide'}`}>
                                    {f.value}
                                </h1>
                            );
                        }

                        if (f.key === 'address') {
                            return (
                                <div key={`header-f-${i}`} className={`flex items-start ${textAlign === 'center' ? 'justify-center' : textAlign === 'right' ? 'justify-end' : 'justify-start'} ${subTextColorClass} whitespace-pre-line leading-snug mb-1 ${isPdfMode ? 'text-[10pt] max-w-[500px]' : 'text-sm opacity-90'}`}>
                                    <div className="flex items-center justify-center shrink-0 pt-[2px]" style={{ marginRight: GLOBAL_ICON_CONFIG.spacingRight }}>
                                        {getIcon('address')}
                                    </div>
                                    <span>{f.value}</span>
                                </div>
                            );
                        }

                        return (
                            <div key={`header-f-${i}`} className={`flex flex-wrap gap-x-4 gap-y-1 ${textAlign === 'center' ? 'justify-center' : textAlign === 'right' ? 'justify-end' : 'justify-start'}`}>
                                <span className={`flex items-center ${subTextColorClass} font-medium ${isPdfMode ? 'text-[9pt]' : 'text-sm opacity-90'}`}>
                                    <div className="flex items-center justify-center shrink-0" style={{ marginRight: GLOBAL_ICON_CONFIG.spacingRight }}>
                                        {getIcon(f.label || f.key)}
                                    </div>
                                    {f.key !== 'email' && f.key !== 'phone' && <span className="font-semibold mr-1">{f.label || f.key}:</span>} {f.value}
                                </span>
                            </div>
                        );
                    })}

                </div>
            )}
        </div>
    );
};

export const TemplateFooter = ({
    isPdfMode,
    footerBg,
    footerTextClass,
    footerText,
    showCompanyInfoFooter,
    footerFields,
    enableQR,
    qrUrl,
}) => {

    const containerClasses = isPdfMode
        ? "w-full py-6 px-20 flex items-center justify-between z-20 mt-auto shrink-0"
        : `h-auto flex items-center justify-between px-8 py-4 gap-6 transition-colors duration-300 ${footerTextClass}`;

    const textWrapperClasses = isPdfMode
        ? `flex flex-col flex-1 pr-6 items-start text-left justify-center ${footerTextClass}`
        : "flex flex-col flex-1 items-start text-left text-xs leading-relaxed";

    const pTextClasses = isPdfMode
        ? "text-[9pt] font-semibold tracking-wide uppercase mb-2"
        : "font-semibold text-sm mb-2";

    const fieldContainerClasses = isPdfMode
        ? "flex flex-row flex-wrap items-center gap-x-6 gap-y-2 opacity-90 text-[8pt]"
        : "flex flex-row flex-wrap items-center gap-x-6 gap-y-2 text-[10px] opacity-90 font-mono";

    return (
        <div
            className={containerClasses}
            style={{
                backgroundColor: footerBg,
                minHeight: FOOTER_MIN_HEIGHT
            }}
        >
            <div className={textWrapperClasses}>
                {footerText && <p className={pTextClasses}>{footerText}</p>}
                {showCompanyInfoFooter && (
                    <div className={fieldContainerClasses}>
                        {footerFields.map((f, i) => {
                            if (f.isVisible && f.value) {
                                return (
                                    // 🔥 Back to standard Flexbox!
                                    <span key={i} className="flex items-center shrink-0">
                                        <div className="flex items-center justify-center shrink-0" style={{ marginRight: GLOBAL_ICON_CONFIG.spacingRight }}>
                                            {getIcon(f.label || f.key, GLOBAL_ICON_CONFIG.footerIconSize)}
                                        </div>
                                        <span className="leading-snug">
                                            {f.key !== 'email' && f.key !== 'phone' && f.key !== 'address' && f.key !== 'name' && (
                                                <span className="font-semibold mr-1">{f.label}:</span>
                                            )}
                                            {f.value}
                                        </span>
                                    </span>
                                );
                            }
                            return null;
                        })}
                    </div>
                )}
            </div>

            {enableQR && qrUrl && (
                <a
                    href={qrUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="relative group cursor-pointer shrink-0 inline-block hover:opacity-90 transition-opacity ml-4"
                >
                    <div
                        title={qrUrl}
                        className={`bg-white rounded shadow-sm border border-white/20 ${isPdfMode ? 'p-2' : 'p-1'}`}
                    >
                        <QRCode value={qrUrl} size={60} fgColor="#000000" bgColor="#FFFFFF" level="L" />
                    </div>

                    {!isPdfMode && (
                        <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block w-max max-w-xs bg-slate-800 text-white text-[10px] font-mono px-2 py-1.5 rounded shadow-lg z-50 break-words pointer-events-none no-print">
                            {qrUrl}
                            <div className="absolute top-full right-6 border-4 border-transparent border-t-slate-800"></div>
                        </div>
                    )}
                </a>
            )}
        </div>
    );
};